<template>
      <div class="overflow-x-hidden" v-if="localSalary">
        <v-row no-gutters>
          <v-col cols="2" class="pb-4 px-4" v-if="$router.currentRoute.params.id===undefined&&localSalary.id">
            <v-sheet :height="height-48" class="overflow-y-auto py-4">
            <v-btn  block small depressed class="mb-3" @click="salaryTemplateAttachDialog=true">Привязать к профилю</v-btn>

            <dialog-editor :item.sync="salaryTemplateAttachDialog" name="Привязать к профилю" submitText="Привязать к профилю" @submit="salaryAttachAction()" disableOverlayClick>
              <user-autocomplete-single
                name="Пользователь"
                :select.sync="attachForm.user"
                :exclude="localSalary.salarys.map(i=>i.user.id)"
              />
              <date name="С даты" :value.sync="attachForm.begin" class="mb-4" />

              <com-branch-autocomplete-single :select.sync="attachForm.comBranch"/>
            </dialog-editor>

             <template v-for="(salary,index) in localSalary.salarys">
                <div class="d-flex align-center justify-space-between py-1" :key="'user_'+salary.id+index">
                  <div>
                    <UserFullName :user="salary.user" type="spec" avatar short/> 
                    <span class="caption"><ComBranchTooltip :comBranch="salary.comBranch" noText/> {{ $tools.date(salary.begin) }}</span>
                  </div>  
                  <btn-icon-accept  icon="mdi-close" text="Отвязать профиль?" @accept="salaryDetach(salary.id)"/>                
                </div>
                <v-divider :key="index"/>
              </template>
            </v-sheet>
          </v-col>
          <v-col cols="4" class="pb-0">
            <v-sheet :height="height-48" class="overflow-y-auto pa-4">
              <v-row class="rowSmall">
                <v-col cols="12">
                    <text-field
                        v-if="$router.currentRoute.params.id===undefined"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :name="'Название профиля'"
                        :value.sync="localSalary.name"
                        required
                    />
                </v-col>
                <template v-if="$router.currentRoute.params.id!==undefined">
                  <v-col>
                    <date name="С даты" :value.sync="localSalary.begin" class="mb-4" />
                  </v-col>
                  <v-col>
                    <com-branch-autocomplete-single :select.sync="localSalary.comBranch"/>
                  </v-col>
                  <v-col cols="12" v-if="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null" class="mt-n7">
                    <alert>Настройки схемы переопределы профилем<br/>"{{localSalary.salaryTemplate.name}}"</alert>
                  </v-col>
                </template>
              </v-row>
              <text-area-field name="Комментарий" :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null" :value.sync="localSalary.comment" />
              <v-row class="rowSmall">
                <v-col>
                  <sheet-group :active="localSalary.createVisitMode!=='disabled'">
                    <radios
                        name="За создание визита"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :items="[{id:'disabled',name:'Не начислять'},{id:'fixed',name:'Фиксированно за каждый визит'},{id:'percent',name:'Процент от суммы визита'}]"
                        :select="{id:localSalary.createVisitMode}"
                        @update:select="(v)=>localSalary.createVisitMode=v.id"
                    />
                    <text-field
                        v-if="localSalary.createVisitMode!=='disabled'"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :name="localSalary.createVisitMode==='fixed' ? 'Сумма' : 'Процент'"
                        :value.sync="localSalary.createVisit"
                        format="^[0-9]+\.?[0-9]?[0-9]?$" formatExample="100, 10.10"
                    />
                  </sheet-group>
                </v-col>
                <v-col>
                  <sheet-group :active="localSalary.refMode!=='disabled'">
                    <radios
                        name="За направление"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :items="[{id:'disabled',name:'Не начислять'},{id:'fixed',name:'Фиксированно за каждое направление'},{id:'percent',name:'Процент от суммы визита'}]"
                        :select="{id:localSalary.refMode}"
                        @update:select="(v)=>localSalary.refMode=v.id"
                    />
                    <text-field
                        v-if="localSalary.refMode!=='disabled'"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :name="localSalary.refMode==='fixed' ? 'Сумма' : 'Процент'"
                        :value.sync="localSalary.ref"
                        format="^[0-9]+\.?[0-9]?[0-9]?$" formatExample="100, 10.10"
                    />
                  </sheet-group>
                </v-col>
                <v-col>
                  <sheet-group :active="localSalary.regMode!=='disabled'">
                    <radios
                        name="За оформление"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :items="[{id:'disabled',name:'Не начислять'},{id:'fixed',name:'Фиксированно за каждый визит'},{id:'percent',name:'Процент от суммы визита'}]"
                        :select="{id:localSalary.regMode}"
                        @update:select="(v)=>localSalary.regMode=v.id"
                    />
                    <text-field
                        v-if="localSalary.regMode!=='disabled'"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :name="localSalary.regMode==='fixed' ? 'Сумма' : 'Процент'"
                        :value.sync="localSalary.reg"
                        format="^[0-9]+\.?[0-9]?[0-9]?$" formatExample="100, 10.10"
                    />
                  </sheet-group>
                </v-col>
                <v-col>
                  <sheet-group :active="localSalary.renMode!=='disabled'">
                    <radios
                        name="За оказание услуги"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :items="[{id:'disabled',name:'Не начислять'},{id:'fixed',name:'Фиксированно за каждую услугу'},{id:'percent',name:'Процент от суммы услуги'}]"
                        :select="{id:localSalary.renMode}"
                        @update:select="(v)=>localSalary.renMode=v.id"
                    />
                    <text-field
                        v-if="localSalary.renMode!=='disabled'"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :name="localSalary.renMode==='fixed' ? 'Сумма' : 'Процент'"
                        :value.sync="localSalary.ren"
                        format="^[0-9]+\.?[0-9]?[0-9]?$" formatExample="100, 10.10"
                    />
                  </sheet-group>
                </v-col>
                <v-col cols="6">
                  <sheet-group>
                    <radios
                        name="Ставка"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :items="[
                              {id:'salaryMonth',name:'Оклад в месяц'},
                              {id:'salaryHour',name:'Оклад в час'},
                              {id:'salaryDay',name:'Оклад в день'},                           
                              {id:'salaryMinHour',name:'Минимальная ставка в час'},
                              {id:'salaryMinDay',name:'Минимальная ставка в день'},
                              {id:'salaryMinMonth',name:'Минимальная ставка в месяц'},
                          ]"
                        :select="{id:localSalary.rateMode}"
                        @update:select="(v)=>localSalary.rateMode=v.id"
                    />
                    <text-field
                        name="Сумма"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :value.sync="localSalary.rate"
                        format="^[0-9]+\.?[0-9]?[0-9]?$" formatExample="100, 10.10"
                    />
                  </sheet-group>
                </v-col>
                <v-col cols="6">
                  <sheet-group :active="localSalary.rateMaxMode!=='disabled'">
                    <radios
                        name="Максимальный лимит"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :items="[
                              {id:'disabled',name:'Отключить'},
                              {id:'salaryMaxMonth',name:'В месяц'},
                          ]"
                        :select="{id:localSalary.rateMaxMode}"
                        @update:select="(v)=>localSalary.rateMaxMode=v.id"
                    />
                    <text-field
                        v-if="localSalary.rateMaxMode!=='disabled'"
                        name="Сумма"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :value.sync="localSalary.rateMax"
                        format="^[0-9]+\.?[0-9]?[0-9]?$" formatExample="100, 10.10"
                    />
                  </sheet-group>
                </v-col>
                <v-col cols="6">
                  <sheet-group>
                    <radios
                        name="Учитывать скидку пациента на оказанную услугу при расчете з/п"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :items="[
                          {id:false,name:'Нет'},
                          {id:true,name:'Да'},
                      ]"
                        :select="{id:localSalary.isRateServiceDiscount}"
                        @update:select="(v)=>localSalary.isRateServiceDiscount=v.id"
                    />
                  </sheet-group>
                </v-col>
                <v-col cols="6">
                  <sheet-group>
                    <radios
                        name="Считать з/п от маржи"
                        :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                        :items="[
                          {id:false,name:'Нет'},
                          {id:true,name:'Да'},
                      ]"
                        :select="{id:localSalary.isCountingFromMargin}"
                        @update:select="(v)=>localSalary.isCountingFromMargin=v.id"
                    />
                  </sheet-group>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
          <v-col :cols="$router.currentRoute.params.id===undefined ? 6 : 8" class="pb-4 px-4">
            <sheet-group>
              <template v-slot:header>
                <v-toolbar dense elevation="0" color="transparent" max-height="48px">
                  <v-toolbar-title class="body-2 font-weight-medium mr-2">Услуги</v-toolbar-title>
                  <v-spacer/>
                  <v-btn :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null" small depressed class="mr-2" @click="serviceAddOpen=true">Добавить услугу</v-btn>
                  <visit-service-add
                      :open.sync="serviceAddOpen"
                      showDeletedCheckbox
                      @complete="(arr)=>{
                      arr.forEach(v1=>{
                        if(localSalary.salaryServices.filter(v2=>parseInt(v2.service.id)===parseInt(v1.id)).length===0)
                          localSalary.salaryServices.push({
                            service: {id:v1.id,name:v1.name,priceTotal:v1.price},
                            renMode: 'fixed',
                            ren: '100.00'
                          })
                      })
                    }"
                  />
                  <btn-small-accept
                    name="Удалить услугу"
                    text="Вы уверены что хотите удалить отмеченные услуги?"
                    :disabled="salaryServicesSelects.length===0 || localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                    @accept="
                      localSalary.salaryServices=localSalary.salaryServices.filter(v1=>salaryServicesSelects.filter(v2=>v1.service.id===v2.service.id).length===0);
                      salaryServicesSelects = [];
                      tableKey++;
                    "
                  />
                </v-toolbar>
              </template>
              <v-data-table
                  :key="tableKey"
                  class="tableMultipleSelect mt-n4"
                  dense
                  :headers="[
                  { text: 'ID', value: 'id', align: 'start', class:'text-no-wrap'},
                  { text: 'Название', value: 'name' },
                  { text: 'Стоимость', value: 'price', class:'text-no-wrap', sortable: false },
                  { text: 'За оказание услуги', value: 'ren', class:'text-no-wrap' },
                ]"
                  :items="localSalary.salaryServices"
                  :footer-props="{'items-per-page-options': [100,500,1000]}"
                  :items-per-page="100"
                  :height="height-164"
                  sort-by="sort"
                  show-select
                  fixed-header
              >
                <template v-slot:header.data-table-select>
                  <v-checkbox :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null" v-model="selectedAll" :indeterminate="selectedAllIndeterminate" class="ma-0 pa-0" dense hide-details />
                </template>
                <template v-slot:item="{item}">
                  <tr>
                    <td>
                      <v-checkbox
                          :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                          @click.stop="
                          salaryServicesSelects.filter(v=>v.service.id===item.service.id).length>0 ?
                          salaryServicesSelects=salaryServicesSelects.filter(v=>v.service.id!==item.service.id) :
                          salaryServicesSelects.push(item)
                        "
                          :input-value="salaryServicesSelects.filter(v=>v.service.id===item.service.id).length>0"
                          class="ma-0 pa-0" dense hide-details
                      />
                    </td>
                    <td>{{item.service.id}}</td>
                    <td class="text-wrap">{{item.service.name}}</td>
                    <td class="text-no-wrap">{{$tools.price(item.service.priceTotal)}}</td>
                    <td class="pt-2">
                      <v-sheet color="transparent" width="296">
                        <v-row class="rowSmall">
                          <v-col cols="auto">
                            <v-sheet color="transparent" width="150" class="pt-1">
                              <tooltip bottom>
                                <v-btn
                                :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                                x-small 
                                depressed 
                                icon 
                                depresse 
                                Tooltip
                                @click="item.renMode='fixed'" 
                                :color="item.renMode==='fixed' ? 'primary' : 'grey'">
                                  <v-icon>mdi-currency-rub</v-icon>
                                </v-btn>
                                <template v-slot:content>
                                  Сумма
                                </template>
                              </tooltip>
                
                              <tooltip bottom>
                                <v-btn class="ml-3" 
                                :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                                x-small 
                                depressed 
                                icon 
                                depresse 
                                Tooltip
                                @click="item.renMode='percent'" 
                                :color="item.renMode==='percent' ? 'primary' : 'grey'">
                                  <v-icon>mdi-percent-outline</v-icon>
                                </v-btn>
                                <template v-slot:content>
                                  Процент
                                </template>
                              </tooltip>

                            </v-sheet>
                          </v-col>
                          <v-col cols="auto">
                            <v-sheet color="transparent" width="120">
                              <text-field
                                  :disabled="localSalary.salaryTemplate !== undefined && localSalary.salaryTemplate !== null"
                                  :name="item.renMode==='fixed' ? 'Сумма' : 'Процент'"
                                  :value.sync="item.ren"
                                  format="^[0-9]+\.?[0-9]?[0-9]?$" formatExample="100, 10.10"
                                  class="mb-0"
                              />
                            </v-sheet>
                          </v-col>
                        </v-row>
                      </v-sheet>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </sheet-group>
          </v-col>
        </v-row>
      </div>
</template>

<script>
import Api from "@/Api";
import axios from "axios";
import moment from "moment";
import Alert from "@/componentsV2/base/Alert.vue";
import Date from "@/componentsV2/base/Date.vue";
import Radios from "@/componentsV2/base/Radios.vue";
import SheetGroup from "@/componentsV2/base/SheetGroup.vue";
import TextAreaField from "@/componentsV2/base/TextAreaField.vue";
import TextField from "@/componentsV2/base/TextField.vue";
import ComBranchAutocompleteSingle from "@/componentsV2/custom/ComBranchAutocompleteSingle.vue";
import BtnSmallAccept from "@/componentsV2/base/BtnSmallAccept.vue";
import VisitServiceAdd from "@/views/Visit/VisitServiceAdd.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import BtnIconAccept from "@/componentsV2/base/BtnIconAccept.vue";
import DialogEditor from "@/componentsV2/base/DialogEditor.vue";
import UserAutocompleteSingle from "@/componentsV2/custom/UserAutocompleteSingle.vue";
import ComBranchTooltip from "@/componentsV2/custom/ComBranchTooltip.vue";


export default {
  components: {
    Alert,
    Date, 
    Radios,
    SheetGroup,
    TextAreaField,
    TextField,
    ComBranchAutocompleteSingle,
    BtnSmallAccept,
    VisitServiceAdd,
    Tooltip,
    UserFullName,
    BtnIconAccept,
    DialogEditor,
    UserAutocompleteSingle,
    ComBranchTooltip
  },
  props:['salary','height'],
  data: () => ({
    localSalary:{
      id:null,
      comment: null,
      begin: moment().format('DD.MM.YYYY'),
      comBranch:null,
      createVisitMode: "fixed",
      createVisit: null,
      renMode: "fixed",
      ren: null,
      refMode: "fixed",
      ref: null,
      regMode: "fixed",
      reg: null,
      rateMode: "salaryMonth",
      rate: null,
      rateMaxMode: "disabled",
      rateMax: null,
      isRateServiceDiscount: false,
      isCountingFromMargin: false,
      salaryServices: [],
      salaryTemplate: null
    },
    tableKey:0,

    salaryServicesSelects:[],
    serviceAddOpen:false,

    salaryTemplateAttachDialog:null,

    attachForm: {
       user: null,
       begin: null,
       comBranch: null
    },
    baseAttachForm: null
  }),
  mounted() {
    this.baseAttachForm = this.$tools.copy(this.attachForm);

    this.$nextTick(() => {
      if (!this.salary||Object.keys(this.salary).length === 0) { // если создаем новый, то localSalary берём за основу
        this.$emit('update:salary',this.localSalary);
      } else {
        this.localSalary = this.salary;
      }     
    });
  },
  watch:{
    salary() {
      this.localSalary = this.salary;
    },
    localSalary: {
      deep: true,
      handler () {
        if (this.localSalary?.salaryTemplateServices) // если редактируем профиль
          this.localSalary.salaryServices = this.localSalary.salaryTemplateServices
      },
    },
  },
  computed:{
    selectedAll:{
      get() {
        return this.localSalary.salaryServices.length>0 && this.localSalary.salaryServices.length===this.salaryServicesSelects.length;
      },
      set(v) {
        this.salaryServicesSelects = v ? this.localSalary.salaryServices : [];
      }
    },
    selectedAllIndeterminate:{
      get() {
        return this.salaryServicesSelects.length>0 && this.salaryServicesSelects.length!==this.localSalary.salaryServices.length;
      }
    },
  },
  methods:{
    salaryAttachAction(){
      let data = this.$tools.copy(this.attachForm)
      if(data.user) {
        axios.put(Api.host+'/salary/',{
          userId: parseInt(data.user.id),
          begin: this.$tools.isEmpty(data.begin) ? moment().format('YYYY-MM-DD') : moment(data.begin, 'DD.MM.YYYY').format('YYYY-MM-DD'),
          comBranchId: this.$tools.isEmpty(data.comBranch) ? null : data.comBranch.id,
          salaryTemplateId: this.localSalary.id
        }).then((r)=>{
          this.localSalary.salarys.push({id:r.data.salaryId,user:data.user});
          this.salaryTemplateAttachDialog=null;
          this.attachForm = this.$tools.copy(this.baseAttachForm);
          this.$store.commit('alertSuccess', 'Пользователь привязан к профилю');
          this.$emit('update');
        }).catch(()=>{
        });
      } else {
        this.$store.commit('alertWarning', 'Пользователь не выбран');
      }
    },
    salaryDetach(salaryId){
      axios.put(Api.host+'/salary/'+salaryId+'/detach/').then(()=>{
        this.localSalary.salarys = this.localSalary.salarys.filter(i=>i.id!==salaryId);
        this.$store.commit('alertSuccess', 'Пользователь отвязан от профиля');
      }).catch(()=>{
      });
    },
  }
};
</script>